var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarhartt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3293 5.11964C12.3293 8.105 12.3293 11.0146 12.3293 13.9892C11.8534 13.9892 11.4099 14 10.9664 13.9892C9.34393 13.9675 7.71064 14.0757 6.10979 13.881C3.31913 13.5457 1.16664 12.2153 0.301317 9.37053C-0.931766 5.2927 1.75073 0.857926 5.95836 0.133219C7.689 -0.169643 9.41965 0.00342256 10.9231 1.07426C11.5721 1.52855 12.0589 2.12346 12.2103 2.9347C12.3293 3.60533 11.9723 4.35166 11.4099 4.62208C10.7825 4.91412 9.9821 4.76269 9.58189 4.26513C9.1276 3.71349 9.10597 2.96715 9.51699 2.35061C9.85231 1.86386 10.3499 1.7557 10.9015 1.7557C10.2309 1.08507 8.83555 1.29059 8.01349 2.15591C7.02919 3.20511 7.12654 5.02229 8.21901 5.94169C9.43046 7.00171 11.107 6.67721 12.3293 5.11964Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarhartt);
export default __webpack_public_path__ + "static/media/icon-carhartt.01b99053d4edcf0be5ec0639a0ebe03a.svg";
export { ForwardRef as ReactComponent };